import bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';

console.log('app env', process.env.NODE_ENV);

const bugsnagClient = bugsnag.start({
  apiKey: process.env.REACT_APP_BUGSNAG_KEY,
  releaseStage: process.env.REACT_APP_ENV,
  enabledReleaseStages: ['prod', 'stag'],
  plugins: [new BugsnagPluginReact()],
});

// wrap your entire app tree in the ErrorBoundary provided
export const ErrorBoundary = bugsnag.getPlugin('react').createErrorBoundary(React);

export const notify = bugsnagClient.notify;
